<template>
  <main class="content">
    <!-- content -->
    <section class="intro intro-2">
      <div class='container'>
        <div class="intro__wrapper">
          <div class="intro__upline">
            <div class="intro__column-left intro-text">
              <h1 class="intro-text__title intro-2-text__title">
                {{group.name}}
              </h1>
              <p class="intro-text__subtitle intro-2-text__subtitle" v-if="group.cf[343]">
                {{group.cf[343]}}
              </p>
            </div>
            <div class="intro__column-right intro-video" v-if="group.cf[344]">
              <iframe :src="group.cf[344]"></iframe>
            </div>
          </div>
          <div class="intro__item item-intro" data-da="win__wapper,0,767">
            <div class="item-intro__column">
              <div class="item-intro__img">
                <svg class="item-intro__svg">
                  <use xlink:href="#1"></use>
                </svg>
              </div>
              <p class="item-intro__text" v-if="group.cf[398]">
                {{group.cf[398]}}
              </p>
              <p class="item-intro__text" v-else>
                Получаете комплект необходимых документов чтобы выиграть свое дело. Готовите их по нашим
                шаблонам или доверяете подготовку нам.
              </p>
            </div>
            <div class="item-intro__column">
              <div class="item-intro__img">
                <svg class="item-intro__svg">
                  <use xlink:href="#2"></use>
                </svg>
              </div>
              <p class="item-intro__text" v-if="group.cf[399]">
                {{group.cf[399]}}
              </p>
              <p class="item-intro__text" v-else>
                У вас будет чёткая инструкция действий.Идете с этими документами в суд или решаете в досудебном
                порядке
              </p>
            </div>
            <div class="item-intro__column">
              <div class="item-intro__img">
                <svg class="item-intro__svg">
                  <use xlink:href="#3"></use>
                </svg>
              </div>
              <p class="item-intro__text" v-if="group.cf[400]">
                {{group.cf[400]}}
              </p>
              <p class="item-intro__text" v-else>
                Выигрываете дело. Без рисков и затрат на юристов
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="win" v-if="group.cf[345] || group.cf[346] || group.cf[347]">
      <div class='container'>
        <div class="win__wapper wrapper-win">
          <h2 class="win__title">
            Как выигрываются дела
          </h2>
          <div class="win__box box-win">
            <div class="win__items" v-if="group.cf[345]">
              <div class="win__card">
                <span class="win__items-number"><span>1</span></span>
                <p class="win__items-text">
                  {{group.cf[345]}}
                </p>
              </div>

            </div>
            <div class="win__items" v-if="group.cf[346]">
              <div class="win__card">
                <span class="win__items-number"><span>2</span></span>
                <p class="win__items-text">
                  {{group.cf[346]}}
                </p>
              </div>
            </div>
            <div class="win__items" v-if="group.cf[347]">
              <div class="win__card">
                <span class="win__items-number"><span>3</span></span>
                <p class="win__items-text">
                  {{group.cf[347]}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="slider">
      <div class='container'>
        <div class="slider__wrapper">
          <h1 class="slider__title">Выбери свою ситуацию</h1>
          <div class="slider__container">
            <!-- Slider main container -->
            <div class="swiper-container" data-mobile="false">
              <!-- Additional required wrapper -->
              <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-for="service in services" :key="service.id" v-if="parseInt(service.cf[341]) === group.id">
                  <div class="slider-item">
                    <p>{{service.name}}</p>
                    <h3 class="slider-item__text">{{service.cf[342]}}</h3>
                    <router-link :to="'/services/' + service.id">Подробнее <span><picture><source srcset="/static/img/slider/bt.svg" type="image/webp"><img src="/static/img/slider/bt.svg" alt="Кнопка" /></picture></span> </router-link>
                  </div>
                </div>
              </div>

            </div>
            <!-- If we need navigation buttons -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="info">
      <div class='container'>
        <div class="info__wrapper">
          <div class="info__up" v-if="group.cf[348] || group.cf[349] || group.cf[350] || group.cf[351]">
            <div class="info__black black-info" v-if="group.cf[348] || group.cf[349]">
              <h2 class="black-info__title" v-if="group.cf[348]">{{group.cf[348]}}</h2>
              <p class="black-info__text" v-if="group.cf[349]">{{group.cf[349]}}</p>
            </div>
            <div class="info__white white-info" v-if="group.cf[350] || group.cf[351]">
              <h2 class="white-info__title" v-if="group.cf[350]">{{group.cf[350]}}</h2>
              <ol class="white-info__list" v-if="group.cf[351]">
                <slot>
                  <li style="list-style: none" v-if="cf" v-for="(cf, i) in group.cf[351].split('\n')" :key="i">{{cf}}</li>
                </slot>
              </ol>
              <div class="white-info__btn">
                <button><span>Получить документы</span></button>
              </div>
            </div>
          </div>
          <div class="info__down" v-if="group.cf[352] || group.cf[353] || group.cf[354] || group.cf[355] || group.cf[356] || group.cf[357]">
            <h1 class="info__down-title">Примеры дел, выигранных с нами</h1>
            <div class="info__content content-info">
              <div class="content-info__items items-info" v-if="group.cf[352] || group.cf[353] || group.cf[354]">
                <div class="items-info__up">
                  <span class="items-info__img" v-if="group.cf[352]"><picture><img :src="group.cf[352]" alt="Фото" /></picture></span>
                  <div class="items-info__text items-info__text--green" v-if="group.cf[353]"><p>{{group.cf[353]}}</p></div>
                </div>
                <div class="items-info__down" v-if="group.cf[354]">
                  <p>{{group.cf[354]}}</p>
                </div>

              </div>
              <div class="content-info__items items-info" v-if="group.cf[355] || group.cf[356] || group.cf[357]">
                <div class="items-info__up">
                  <span class="items-info__img" v-if="group.cf[355]"><picture><img :src="group.cf[355]" alt="Фото" /></picture></span>
                  <div class="items-info__text items-info__text--red" v-if="group.cf[356]"><p>{{group.cf[356]}}</p></div>
                </div>
                <div class="items-info__down" v-if="group.cf[357]">
                  <p>{{group.cf[357]}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="for-whom">
      <div class='container'>
        <div class="for-whom__wrapper">
          <h1 class="for-whom__title">Для кого</h1>
          <ul class="for-whom__list">
            <li v-if="group.cf[358]">{{group.cf[358]}}</li><li v-else>Для тех, кому предстоит суд по лишению прав</li>
            <li v-if="group.cf[359]">{{group.cf[359]}}</li><li v-else>Для тех, кого уже лишили и кто хочет вернуть права досрочно</li>
            <li v-if="group.cf[360]">{{group.cf[360]}}</li><li v-else>Для тех, кто сомневается в качестве работы своего юриста или просто хочет проверить его работу</li>
            <li v-if="group.cf[361]">{{group.cf[361]}}</li><li v-else>Для начинающих юристов, помощников юристов и студентов</li>
            <li v-if="group.cf[362]">{{group.cf[362]}}</li>
          </ul>
          <div class="for-whom__form form-whom">
            <div class="form-whom__wrapper">

              <div class="form-whom__input" style="flex: 0 1 100%;margin-right: 0;">
                <input autocomplete="off" :value="group.name" disabled readonly class="input"/>
              </div>
              <div class="form-whom__input" style="flex: 0 1 100%;margin-right: 0;">
                <div :class="selectService.show?'nice-select select-block open':'nice-select select-block'" @click="selectService.show=1" @focusout="selectService.show=0" tabindex="0">
                  <span class="current">{{selectService.name}}</span>
                  <ul class="list">
                    <li v-for="service in services" :key="service.id" :class="selectService.id===service.id?'option selected focus':'option'"  v-if="parseInt(service.cf[341]) === parseInt(group.id)" @click="selectService.id = service.id, selectService.name = service.cf[403]">
                      {{service.cf[403]}}</li>
                  </ul>
                </div>
              </div>
              <div class="form-whom__input">
                <input autocomplete="off" type="text" class="input" placeholder="Город" v-model="city"/>
              </div>
              <div class="form-whom__input">
                <input autocomplete="off" type="text" class="input" placeholder="Имя" v-model="name"/>
              </div>
              <div class="form-whom__input">
                <input autocomplete="off" type="tel" class="input" placeholder="Телефон" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
              </div>

              <div class="form-whom__input">
                <input autocomplete="off" type="email" class="input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
              </div>
              <div class="form-whom__btn-wrapper">
                <button class="form-whom__btn" @click="sendQuestion"><span>Получить документы по моему делу</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  import axios from '@/router/http'
  import Inputmask from 'inputmask'
  export default {
    name: 'group',
    data () {
      return {
        group: { cf: {} },
        services: [],
        selectService: {id: null, show: 0, name: null},
        name: null,
        email: null,
        phone: null,
        city: null
      }
    },
    methods: {
      initPage () {
        axios.get('https://urist1.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
          this.group = response.data
          if (!this.group.cf) this.group.cf = {}
          axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=32').then(response => {
            this.services = response.data

            setTimeout(() => {
              this.initSlider()
            }, 1000)
          })
        })
      },
      initSlider () {
        var slider = document.querySelector('.swiper-container')
        if (slider === null) {
          return
        }
        let swiper
        function desctopSlider () {
          if (window.innerWidth >= 320 && slider.dataset.mobile === 'false') {
// eslint-disable-next-line
            swiper = new Swiper(slider, {
              pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
              },
              observer: true,
              observeParents: true,
              slidesPerView: 3,
              spaceBetween: 0,
              speed: 800,
              loop: false,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              breakpoints: {
                320: {
                  slidesPerView: 1
                },
                567: {
                  slidesPerView: 2
                },

                768: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1292: {
                  slidesPerView: 3
                }
              }
            })

            slider.dataset.mobile = 'true'
          }
          if (window.innerWidth < 320) {
            slider.dataset.mobile = 'false'

            swiper.destroy()
          }
        }
        desctopSlider()
        window.addEventListener('resize', () => {
          desctopSlider()
        })
      },
      sendQuestion () {
        if (!this.email) alert('Вам необходимо указать E-mail')
        else {
          var formData = new FormData()
          formData.append('crm', '9')
          formData.append('pipe', '17')
          formData.append('contact[name]', this.name)
          formData.append('contact[141]', this.phone)
          formData.append('contact[142]', this.email)
          formData.append('contact[143]', this.city)
          formData.append('lead[147]', this.city)
          formData.append('lead[404]', this.group.name)
          formData.append('lead[145]', this.selectService.name)
          axios.post('https://urist1.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          setTimeout(() => { alert('Спасибо, ваша заявка отправлена') }, 1)
        }
      }
    },
    mounted () {
      this.initPage()
      Inputmask().mask(document.querySelectorAll('input'))
      setTimeout(() => {
        Inputmask().mask(document.querySelectorAll('input'))
      }, 1000)
    },
    watch: {
      $route (to, from) {
        this.initPage()
      },
      'selectService.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectService.show = 0
          }, 100)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/group.vue